import * as user from '@/store/modules/demo/user.js'
import * as product from '@/store/modules/demo/product.js'

export const namespaced = true

export const modules = {
  user,
  product
}

export const actions = {
  login ({ commit, getters }, user) {
  }
}
